import React from 'react'
import { ScaleLinear } from 'd3-scale'
import { formatSwissDate, config } from 'components/Charts_Assets'
type xTickDataType = { text?: string[]; lines?: string[] }
export const XTicks = ({
  data,
  x,
  y
}: {
  data: xTickDataType
  x: ScaleLinear<string, string, never>
  y: ScaleLinear<number, number>
}) => {
  return (
    <>
      {data.lines &&
        data.lines.map((t, i) => {
          return (
            <line
              key={i}
              y1={y.range()[1]}
              y2={y.range()[0] - 4}
              x1={x(new Date(t))}
              x2={x(new Date(t))}
              className='tickline'
            />
          )
        })}
      {data.text &&
        data.text.map((t, i) => {
          let d = new Date(t).setMonth(5)
          return (
            <text
              key={i}
              x={x(d)}
              y={y.range()[0] + config.textOffsetY}
              className='ticktext'
              textAnchor={'middle'}
            >
              {window.innerWidth < 600
                ? formatSwissDate(t, 'year_only')
                : formatSwissDate(t, 'year_only')}
            </text>
          )
        })}
    </>
  )
}
